module.exports = __webpack_public_path__ + "static/img/jajook.1f9ce924.webp";